import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const BusinessProcess = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Business Process Services</h1>
                <p className="colorWht">GreenOrange BPS is a global leader in providing next generation business process services to global enterprises.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/business_process.jpg" alt="business_process" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                Today, the world markets have matured to be highly industry, process and segment specific, and there has been a major shift from the initial days of business process services that was relatively simpler. Customers now expect business process services providers to deliver best-in-class operations, as well as the transformation needed in order to be the best in their respective industries. It's no longer about operational metrics and SLAs alone, it's about end-to-end process metrics and business outcomes.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside bp-page">
                <div>You may also be interested in <span> our other services</span></div>
                <ul className="pad0">
                  <li><Link to="/applications" title="Applications">Applications</Link></li>
                  <li><Link to="/enterprise-resource-planning" title="ERP">ERP</Link></li>
                  <li><Link to="/consulting" title="Consulting">Consulting</Link></li>
                  <li><Link to="/mobility" title="Mobility">Mobility</Link></li>
                  <li><Link to="/gps-tracking-service" title="GPS Tracking as Service">GPS Tracking as Service</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>How Green Orange Helps?</h2>
                <p>
                  At GreenOrange Business Process Services (BPS) we understand this changing need of customers, and our aim is to delight you through a combination of operational excellence, industry expertise and transformation capabilities. The operational excellence comes from our experience of partnering with multiple global clients over the years, and the industry expertise is based on our focus in select industry verticals at GreenOrange. The transformation journey is powered by our investment in technology and process innovations like robotic process automation and artificial intelligence, intelligent business platforms that work with your existing IT landscape, and analytics that lead to predictive modeling thereby ensuring right business outcomes. Our focus is to work with you to achieve your business goals, and partner for the next level of improvements in order to attain competitive advantage.
                  GreenOrange takes client processes on a journey of progression and continuous improvement. Irrespective of the existing state of the client process / industry / function, the model is geared to transform the process through an evolution curve of higher process maturity, measurable business outcomes, and enhanced client customer satisfaction. This is achieved by leveraging themes of effective service delivery, proficient workforce, knowledge management, automation, risk and compliance.
                </p>
                <p>GreenOrange BPS is a global leader in providing next generation business process services to global enterprises. Our key capabilities are:</p>
                <ul className="">
                  <li>Transformation capability based on customer / industry needs and usage of flexible, innovative solutions including process automation, intelligent business platforms that work with existing IT landscape for the customer.</li>
                  <li>Pre-built Assets focused on process improvements that can be used from Day 1 without significant investment</li>
                  <li>Industry Focused, platform-based Solutions: Integrated IT and BPS solutions, leveraging a large eco-system of Product partnerships and flexible commercial models including BPaaS and Utilities</li>
                  <li>Flexible commercial models to suit varied customer requirements and ability to structure deals accordingly</li>
                  <li>24X7 operations through one standardized process and support.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default BusinessProcess;

